module.exports = __webpack_public_path__ + "img/back_m_active3.e863ddfa.png";